import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsersService } from '../users.service';

@Component({
  selector: 'app-edit-role',
  templateUrl: './edit-role.component.html',
  styleUrls: ['./edit-role.component.scss']
})
export class EditRoleComponent implements OnInit {
  jobs:any;
  name:any;
  allComplete : any;
  completeIndex = [false, false, false, false, false, false, false];
  blockLoader: string = 'blockLoader';

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		private spinner: NgxSpinnerService,
		public dialogRef: MatDialogRef<EditRoleComponent>,
		private usersService: UsersService
	) {
    const d = this.data.roleData;
    // console.log('editing data', d);

    this.jobs = [
      {
        name: 'Learning Center',
        active: false,
        subMenu: [
          {
          name: 'Dashboard',
          active: false,
        },
        {
          name: 'Learn',
          active: false,
        },
        {
          name: 'History',
          active: false,
        },
        {
          name: 'Library',
          active: false,
        },
		{
			name: 'Analytics',
			active: false,
		}
    ]
      },
      {
        name:'Store Visitation',
        active: false,
      },
      {
        name:'Management',
        active: false,
      },
      {
        name:'Creation Center',
        active: false,
        subMenu: [
          {
            name: 'Program Builder',
            active: false,
          },
          {
            name:'Course Builder',
            active: false,
          },
          {
            name:'Audit Builder',
            active: false,
          }
        ]

      },
      {
        name: 'Rewards',
        active:false,
      },
      {
        name:'Analytics',
        active:false,
      }
    ];

    if (d) {
      this.jobs = d.jobs;
      this.name = d.name;

	  for (let i = 0; i < this.completeIndex.length; i += 1) {
		this.updateAllComplete(i);
	  }
    }
  }

  ngOnInit(): void {
  }

  updateAllComplete(i:number) {
    this.completeIndex[i] = this.jobs[i]?.subMenu != null && this.jobs[i]?.subMenu?.every((t:any) => t.active);
  }

  someComplete(i:number): any {
    if(this.jobs[i].subMenu) {
      if (this.jobs[i].subMenu == null) {
        return false;
      }
      return this.jobs[i].subMenu.filter((t:any) => t.active).length > 0 && !this.completeIndex[i];
    }
  }

  setAll(completed: boolean, i:number) {
    console.log(completed,'completed')
    // if(this.jobs[i]?.subMenu?.length){
      console.log(this.completeIndex[i]);
      this.jobs[i].active = completed;
    if (this.jobs[i]?.subMenu == null) {
      return;
    }
    // console.log('this.jobs[i].subMenu.forEach((t:any) => (t.active = completed))',this.jobs[i].subMenu.forEach((t:any) => (t.active = completed)))
     this.jobs[i].subMenu.forEach((t:any) =>{
    //   console.log('tttttttttt',t)
      t.active = completed
     });
    // }
  }

	allCompleteJobs(i: number) {
		const currentJob = this.jobs[i];
		if (currentJob?.subMenu?.length){
			return this.completeIndex[i];
		} else {
			return currentJob['active'];
		}
	}

	async saveRole() {
		let data = {
			name: this.name,
			jobs: this.jobs,
			organisationId: this.data.organisationId,
		};
		await this.spinner.show("blockLoader");
		await this.usersService.addEditRole(data, this.data.roleData ? this.data.roleData.id : '');
		this.dialogRef.close();
		await this.spinner.hide("blockLoader");
	}
}
